export const DisplayNotesType = {
  Card: 1,
  OnlyList: 2,
};

export const NotesListPaginationType = {
  Normal: 1,
  Simple: 2,
  Scroll: 3,
};
